import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const projectDataClassName = DataClassName.PROJECT
const projectEndpoint = PisaDataClassEndpoint.PROJECT

export function pisaProjectDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(projectDataClassName, {
    title: projectDataClassName,
    restApi: createPisaRestApiConfig(projectEndpoint),
    attributes,
  })
}
